module.exports = ".align-buttons {\n  text-align: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-estimate-settlement-report/master-estimate-settlement-report.component.scss
// module id = ./src/app/master/master-estimate-settlement-report/master-estimate-settlement-report.component.scss
// module chunks = main